<script lang="ts">
    import IntegrationToggle from './IntegrationToggle.svelte';
    import clsx from 'clsx';

    // Types
    import type { IntegrationCategory } from '$lib/components/ConsentOverlay/types';

    export let categoryId = '';
    export let title = '';
    export let onToggle: (id: IntegrationCategory | string, value: boolean) => void = () => null;
    export let active = false;
    export let disabledToggle = false;

    let expanded = false;

    const handleExpand = () => {
        expanded = !expanded;
    };

    $: containerClass = clsx('h-0 overflow-hidden', { 'h-auto': expanded });
</script>

<IntegrationToggle
    id={categoryId}
    text={title}
    onExpandClick={handleExpand}
    {onToggle}
    {active}
    {disabledToggle}
    {expanded}
/>
<div class={containerClass}>
    <slot />
</div>
